<template>
  <ion-chip :color="getStatusColor(props.status)" :style="`background-color: ${getAccentColor()}`">
    <ion-icon
      v-if="getIcon()"
      :icon="getIcon()"
      size="small"
      class="pr-sm no-margin-left"
    ></ion-icon>
    {{ props.title }}
  </ion-chip>
</template>
<script setup lang="ts">
  import { getStatusColor } from '@/utils/validations/random-color';
  import { IonChip, IonIcon } from '@ionic/vue';
  import { alertCircle, checkmarkCircle, closeCircleOutline } from 'ionicons/icons';

  const props = withDefaults(
    defineProps<{
      title: string;
      status: string;
      icon?: string;
      accentColor?: string;
    }>(),
    {
      title: '',
      status: '',
      icon: undefined,
    },
  );

  const getIcon = () => {
    switch (props.status) {
      case 'pending':
        return alertCircle;
      case 'sent':
        return alertCircle;
      case 'paid':
        return checkmarkCircle;
      case 'accepted':
        return checkmarkCircle;
      case 'canceled':
        return closeCircleOutline;
      default:
        return undefined;
    }
  };

  const getAccentColor = () => {
    switch (props.status) {
      case 'pending':
        return 'var(--ion-color-orange-tint)';
      case 'sent':
        return 'var(--ion-color-orange-tint)';
      case 'canceled':
        return 'var(--ion-color-error-tint)';
      case 'paid':
        return 'var(--ion-color-success-tint)';
      case 'accepted':
        return 'var(--ion-color-success-tint)';
      default:
        return undefined;
    }
  };
</script>
